import React, { useState } from "react";
import { tradeJson } from "../../utils/tradeApi";

export default function TradePasswordPanel() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function submit(event) {
    event.preventDefault();
    setMessage(""); setError("");
    if (newPassword !== confirmPassword) return setError("New passwords do not match.");
    try {
      const result = await tradeJson("/api/trade/account/change-password", "POST", { currentPassword, newPassword });
      localStorage.setItem("usesDefaultPassword", String(Boolean(result.usesDefaultPassword)));
      setMessage("Password changed successfully.");
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
    } catch (requestError) { setError(requestError.message); }
  }

  return (
    <section className="trade-settings-card">
      <span className="trade-eyebrow trade-green">ACCOUNT</span>
      <h2>Change password</h2>
      <p className="trade-muted">Changing the shared default password is optional. Use at least 8 characters.</p>
      <form className="trade-form compact" onSubmit={submit}>
        <label>Current password<input type="password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required /></label>
        <label>New password<input type="password" minLength="8" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required /></label>
        <label>Confirm new password<input type="password" minLength="8" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required /></label>
        {message && <div className="trade-alert success">{message}</div>}
        {error && <div className="trade-alert error">{error}</div>}
        <button className="trade-button primary" type="submit">Update password</button>
      </form>
    </section>
  );
}
